import React, { Component } from 'react'

class Error extends Component {
  render() {
    const { error } = this.props
    return (
      <div className='alert-error'>
        <i className='fas fa-exclamation-triangle'></i> {error}
      </div>
    )
  }
}

export default Error



// WEBPACK FOOTER //
// ./src/components/Error.js